import { t } from '@/i18n/utils'

/**
 * 标签页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const tagsCommonConfig = {
  texts: {
    get loading() { return `${t('Loading')}...` },
    get allTags() { return t('AllTags') },
    get mostPopular() { return t('TagOrderOne') },
    get newArrival() { return t('TagOrderTwo') },
    get noMore() { return `${t('NoMore')} ~` },
  },
}
